<description-wizard [(prompt)]="prompt"/>
<div class="dx-fieldset" *ngIf="prompt">
  <div class="dx-field">
    <dx-toolbar>
      <dxi-item
        location="after"
        widget="dxButton"
        [options]="{ stylingMode: 'outlined', text: 'Generieren' | translate, width: '100%', onClick: confirmGenerate }"
      />
    </dx-toolbar>
  </div>
  <div class="dx-field" *ngIf="promptResult || loading">
    <div class="dx-field-label">{{ 'Ergebnis' | translate }}</div>
    <div class="dx-field-value">
      <dx-text-area id="promptResult" [value]="promptResult" [readOnly]="true" [autoResizeEnabled]="true"/>
      <dx-load-panel
        #loadPanel
        shadingColor="rgba(0,0,0,0.4)"
        [position]="{ of: '#promptResult' }"
        [(visible)]="loading"
        [showIndicator]="true"
        [showPane]="true"
        [shading]="true"
        [hideOnOutsideClick]="false"
      ></dx-load-panel>
    </div>
  </div>
</div>

<np-description-wizard-field-chooser [(field)]="field" *ngIf="!!promptResult"/>
<div class="dx-fieldset" *ngIf="!!promptResult && !!field">
  <div class="dx-field">
    <dx-toolbar>
      <dxi-item
        location="after"
        widget="dxButton"
        [options]="{ stylingMode: 'outlined', text: 'Anwenden' | translate, width: '100%', onClick: applyResult }"
      />
    </dx-toolbar>
  </div>
</div>


